import React from 'react';
import { Text, Button, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { Grid } from '@mui/material';
import ContentBlock from './ContentBlock.js';

const styles = {
    buttonStyle: {
        height: 40
    },
    contentBlockSmallIconStyle: {
        fontSize: 26,
        marginRight: 25,
        marginTop: 5
    },
    contentBlockStyle: {
        marginBottom: '40px',
        minHeight: 100
    },
    iconGridStyle: {
        display: 'flex',
        alignItems: 'flex-start'
    },
    textGridStyle: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    titleStyle: {
        marginBottom: 5
    },
    buttonGridStyle: {
        display: 'flex',
        alignItems: 'center'
    }
};

/**
 * Opens a link in a new browser tab
 * @param {string} link - The URL to navigate to
 */
const navigateTo = (link) => {
    window.open(link, "_blank");
};

/**
 * Small content block component for displaying perk benefits with icon and action button.
 * Renders a responsive grid layout with an icon, title, description, and action button.
 * @param {React.ComponentType} props.Icon - Icon component to display
 * @param {string} props.titleText - Translation key for the title text
 * @param {string} props.description - Translation key for the description text
 * @param {string} props.link - URL to navigate to when button is clicked
 * @param {string} props.buttonColor - Color for the icon and button text
 * @returns {React.ReactElement} Rendered content block component
 */
const ContentBlockSmall = ({
    Icon,
    titleText,
    description,
    link,
    buttonColor
}) => (
    <ContentBlock customStyle={styles.contentBlockStyle}>
        <Grid item xs="auto" sx={styles.iconGridStyle}>
            <Icon style={{ ...styles.contentBlockSmallIconStyle, color: buttonColor }}/>
        </Grid>

        <Grid item xs sx={styles.textGridStyle}>
            <Text
                medium
                bold
                customStyle={styles.titleStyle}
            >
                {i18n.t(titleText)}
            </Text>
            <Text medium>
                {i18n.t(description)}
            </Text>
        </Grid>

        <Grid item xs={12} sm="auto" sx={styles.buttonGridStyle}>
            <Button
                transparent
                customStyle={styles.buttonStyle}
                onClick={() => navigateTo(link)}
            >
                <Text
                    medium
                    bold
                    color={buttonColor}
                >
                    { i18n.t(tokens.labels.perks.fyiDoctorsShopNow) }
                </Text>
            </Button>
        </Grid>
    </ContentBlock>
);

export default ContentBlockSmall;